import { ApiRouteInterceptorService } from './api-route-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeadersInterceptorService } from './headers-interceptor.service';
import { ProjectAuthorizationInterceptorService } from '@core/http-interceptors/project-authorization-interceptor.service';

import { ImpersonationInterceptorService } from '@core/http-interceptors/impersonation-interceptor.service';
import { AuthHttpInterceptor } from './auth-interceptor.service';
import { CapabilityRefreshInterceptor } from './capability-refresh-interceptor.service';
// import { AuthHttpInterceptor } from '@auth0/auth0-angular';

export const HttpInterceptors = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiRouteInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHttpInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ImpersonationInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HeadersInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ProjectAuthorizationInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CapabilityRefreshInterceptor,
    multi: true,
  },
];
